import type { FieldSchemaModel, PromoProductModel } from '@/shared/generated'
import type { TFunction } from 'i18next'

import { prop } from 'lodash/fp'

import { FieldType, ValueType } from '@/shared/generated'

export default async function buildTableBlob(
	rows: PromoProductModel[],
	t: TFunction
): Promise<Blob> {
	const Excel = await import('exceljs')
	const workbook = new Excel.Workbook()
	workbook.creator = 'Competera Promo'
	workbook.lastModifiedBy = 'Competera Promo'
	workbook.created = new Date()
	workbook.modified = new Date()
	workbook.lastPrinted = new Date()
	const worksheet = workbook.addWorksheet('Sheet1')
	worksheet.addTable({
		name: 'Products',
		ref: 'A1',
		headerRow: true,
		totalsRow: false,
		style: {
			theme: 'TableStyleMedium1',
		},
		columns: schema.map((s) => ({
			name: t(s.name, { defaultValue: s.name }),
			key: s.name,
			filterButton: true,
			width: 150,
		})),
		rows: rows.map((row) => schema.map(({ id }) => prop(id, row))),
	})
	const buffer = await workbook.xlsx.writeBuffer()

	return new Blob([buffer], {
		type: 'application/octet-binary;charset=utf-8',
	})
}
const common = {
	value_editor_type: null,
	options: null,
	config: {
		order: 1,
		path: '',
		aggregation: { optimization_group: null, pricing_line: null },
	},
}
const schema: FieldSchemaModel[] = [
	{
		id: 'sku',
		name: 'products_sku',
		params: {
			searchable: true,
		},
		field_type: FieldType.Text,
		value_type: ValueType.String,
		...common,
	},
	{
		id: 'title',
		name: 'title',
		params: {
			searchable: true,
		},
		field_type: FieldType.Text,
		value_type: ValueType.String,
		...common,
	},
	{
		id: 'discount_percent',
		name: 'discount_percent',
		params: {
			searchable: true,
		},
		field_type: FieldType.Number,
		value_type: ValueType.Number,
		...common,
	},
	{
		id: 'discount_sum',
		name: 'discount_sum',
		params: {
			searchable: true,
		},
		field_type: FieldType.Number,
		value_type: ValueType.Number,
		...common,
	},
	{
		id: 'discount_price',
		name: 'discount_price',
		params: {
			searchable: true,
		},
		field_type: FieldType.Number,
		value_type: ValueType.Number,
		...common,
	},
	{
		id: 'predicted_growth_rate',
		name: 'predicted_growth_rate',
		params: {
			searchable: true,
		},
		field_type: FieldType.Number,
		value_type: ValueType.Number,
		...common,
	},
]
